import {PublicKey} from "@solana/web3.js"
import {Options} from "ipfs-core"

interface AppConfigTypes {
  defaultSnackBarTime: number;
  openLoginClientId: string;
  openLoginNetwork: string;
  ipfsWebSocket: string;
  ipfsConfig: Options;
  orbitTopic: string;
  ipfsPinTopic: string;
  localServerUrl: string;
  solUrl: string;
  solInitRepoProgram: PublicKey;
  defaultAvatar: string;
  linkedInLogo: string;
  twitterLogo: string;
}

export const AppConfig: AppConfigTypes = {
  defaultSnackBarTime: 5000,
  openLoginClientId: "BLNxG_t7zkGDkwdvw23Ruq9f16gSxTA6b9eucfKw6BKMWkxWesBb4fEntEUi7iKiEa-8jNnxYVYD3Nb5X8tlTWE",
  openLoginNetwork: "testnet",
  ipfsWebSocket: "/dns4/gossip.degit.io/tcp/443/wss/p2p/12D3KooWFFtxNmqhYzfZTfXYTM2DjbusUTPvdB7C5tcf8nW4PKTn",
  ipfsConfig: {
    repo: "ipfs",
    config: {
      Pubsub: {
        PubSubRouter: "floodsub",
        Enabled: true
      },
      Bootstrap: [
        "/dnsaddr/bootstrap.libp2p.io/p2p/QmNnooDu7bfjPFoTZYxMNLWUQJyrVwtbZg5gBMjTezGAJN",
        "/dnsaddr/bootstrap.libp2p.io/p2p/QmbLHAnMoJPWSCR5Zhtx6BHJX9KiKNN6tpvbUcqanj75Nb",
        "/dnsaddr/bootstrap.libp2p.io/p2p/QmZa1sAxajnQjVM8WjWXoMbmPd7NsWhfKsPkErzpm9wGkp",
        "/dnsaddr/bootstrap.libp2p.io/p2p/QmQCU2EcMqAqQPR2i9bChDtGNJchTbq5TbXJJ16u19uLTa",
        "/dnsaddr/bootstrap.libp2p.io/p2p/QmcZf59bWwK5XFi76CZX8cbJ4BhTzzA3gU1ZjYZcYW3dwt",
        "/dns4/gossip.degit.io/tcp/443/wss/p2p/12D3KooWFFtxNmqhYzfZTfXYTM2DjbusUTPvdB7C5tcf8nW4PKTn"
      ],
    },
    preload: {
      enabled: false,
    }
  },
  orbitTopic: "orbit-topic-v0-d6059267",
  ipfsPinTopic: "ipfs-pin-v0-1abe5af5",
  localServerUrl: "http://localhost:21560",
  solUrl: "http://localhost:8899",
  solInitRepoProgram: new PublicKey("FJqx4BHBaJjpVY2f1yGLV7bi3hUxVUzBCA1SwSFCztPm"),
  defaultAvatar: "https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg",
  linkedInLogo: "https://play-lh.googleusercontent.com/kMofEFLjobZy_bCuaiDogzBcUT-dz3BBbOrIEjJ-hqOabjK8ieuevGe6wlTD15QzOqw",
  twitterLogo: "https://www.apacph.org/wp/wp-content/uploads/2014/03/Twitter-Logo-New-.png"
}
